import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/tournament/registration-input";

export type TTournamentRegistrationInputTypes = "input" | "select" | "checkbox" | "text";

export interface ITournamentRegistrationInput {
  id: number;
  label: string;
  required: boolean;
  type: TTournamentRegistrationInputTypes;
  help_text: string;
  row: number;
  column: number;
  values: string[] | null;
}

type TGetTournamentRegistrationInput = {
  tournament_id: number;
};

export type TPostTournamentRegistrationInput = {
  tournament_id: number;
  label: string;
  help_text: string;
  type: TTournamentRegistrationInputTypes;
  required?: boolean; // backend defaults to true if not given
};

export type TPutTournamentRegistrationInput = {
  id: number;
  label?: string;
  help_text?: string;
  type?: TTournamentRegistrationInputTypes;
  values?: string[];
  required?: boolean;
};

export type TPutTournamentRegistrationInputPosition = {
  id: number;
  row: number;
  column: number;
};

export type TTournamentRegistrationInputResponse = {
  id: number;
  participant_id: number;
  label: string;
  type: TTournamentRegistrationInputTypes;
  value: string | boolean;
};

type TGetTournamentRegistrationInputResponse = {
  participant_id?: number;
};

type TGetTournamentRegistrationInputResponseExport = {
  tournament_id: number;
};

export async function GetTournamentRegistrationInput(
  params: TGetTournamentRegistrationInput,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<ITournamentRegistrationInput[]>(baseUrl, params, useGlobalLoader, token);
}

export async function PostTournamentRegistrationInput(
  params: TPostTournamentRegistrationInput,
  useGlobalLoader: boolean,
) {
  return await APIPost<ITournamentRegistrationInput>(baseUrl, params, useGlobalLoader);
}

export async function PutTournamentRegistrationInput(params: TPutTournamentRegistrationInput, useGlobalLoader = true) {
  return await APIPut(baseUrl, params, useGlobalLoader);
}

export async function DeleteTournamentRegistrationInput(params: { id: number }, useGlobalLoader = true) {
  return await APIDelete(baseUrl, params, useGlobalLoader);
}

export async function PutTournamentRegistrationInputPositions(
  params: { inputs: TPutTournamentRegistrationInputPosition[] },
  useGlobalLoader = true,
) {
  return await APIPut(baseUrl + "/position", params, useGlobalLoader);
}

export async function GetTournamentRegistrationInputResponse(
  params: TGetTournamentRegistrationInputResponse,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<TTournamentRegistrationInputResponse[]>(
    APIUrl(AdminType.FacilityAdmin, "/tournament/registration-input/response"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function GetTournamentRegistrationInputResponseExport(
  params: TGetTournamentRegistrationInputResponseExport,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<string>(
    APIUrl(AdminType.FacilityAdmin, "/tournament/registration-input/response/export"),
    params,
    useGlobalLoader,
    token,
  );
}
